<template>
  <logged-in-layout>
    <main>
      <activity-summary v-bind="$route.query" />
    </main>
  </logged-in-layout>
</template>

<script>
  import LoggedInLayout from '@/components/logged-in-layout/logged-in-layout'
  import ActivitySummary from './activity-summary'

  export default {
    components: {
      LoggedInLayout,
      ActivitySummary
    }
  }
</script>



// WEBPACK FOOTER //
// activity-summary-route.vue?6fb1de24